import { HttpService } from '@/shared/lib/http'

import type { TGetBlocosResponse } from '../interfaces/bloco.types'

export class GetBlocosService extends HttpService {
  execute = async (empreendimentoId: string) => {
    return this.http.get<TGetBlocosResponse>(`/api/v2/Bloco/empreendimento/${empreendimentoId}`)
  }
}
